import {
  deleteAllFavorites
} from "./chunk-OWEMZM5M.js";
import {
  hasAuthorization
} from "./chunk-NFLWKIRZ.js";
import {
  getErrorResult
} from "./chunk-IPNO7PON.js";

// src/services/deleteAllFavorites/deleteAllFavorites.ts
async function deleteAllFavorites2(apiConfig) {
  if (!hasAuthorization(apiConfig)) {
    console.warn(
      "JWT token is required. Please provide a valid JWT token in the `apiConfig` via `jwtToken` or `headers.Authorization` or provide a `getToken` function in the `apiConfig`"
    );
  }
  try {
    const response = await deleteAllFavorites(apiConfig);
    return {
      status: "success",
      data: response
    };
  } catch (error) {
    apiConfig.onError?.(error);
    return getErrorResult(error);
  }
}

export {
  deleteAllFavorites2 as deleteAllFavorites
};
